<script>
export default {
    name: "LabelVue",
    props: {
        value: {
            type: String,
            required: true,
        },
    },
};
</script>

<template>
    <!-- <label class="block font-medium text-sm text-gray-700"> -->
    <label class="form-label">
        <template v-if="value">{{ value }}</template>
        <template v-else><slot /></template>
    </label>
</template>
